const html = document.documentElement;
let timer;

window.addEventListener(
  'resize',
  () => {
    html.classList.add('is-resizing');
    clearTimeout(timer);
    timer = setTimeout(() => html.classList.remove('is-resizing'), 150);
  },
  { passive: true },
);
